import type { RequiredWhenRule } from '../types';

/**
 * UI mirror of the backend `evaluateRequiredWhen` so the form-fill UI can
 * show/hide conditional fields live as the parent types, without an extra
 * round trip. Keep semantics aligned with `src/forms/utils/zod-from-form.ts`.
 */
export function evaluateRequiredWhen(
  rule: RequiredWhenRule | undefined,
  responses: Record<string, unknown>
): boolean {
  if (!rule) return true;
  const actual = responses[rule.field];
  if ('notEmpty' in rule) {
    if (actual === undefined || actual === null || actual === '') return false;
    if (Array.isArray(actual) && actual.length === 0) return false;
    return true;
  }
  return actual === rule.equals;
}
